import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ThemeProvider } from '@material-ui/core/styles';
import { CssBaseline, StyledEngineProvider } from '@material-ui/core';

import AdapterDateFns from '@material-ui/lab/AdapterDateFns';
import LocalizationProvider from '@material-ui/lab/LocalizationProvider';

// routing
import client from 'client';
import { ApolloProvider } from '@apollo/client';
import Routes from 'routes';

// defaultTheme
// eslint-disable-next-line import/no-named-as-default
import theme from 'themes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from './ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';

// auth providers
import { FirebaseProvider } from 'contexts/FirebaseContext';
// import {JWTProvider} from '../contexts/JWTContext';
// import {Auth0Provider} from '../contexts/Auth0Context';
import { UserProvider } from 'contexts/UserContext';
import { DataProvider } from 'contexts/DataContext';
import { GrowthbookAppProvider } from 'contexts/GrowthbookContext';

import 'react-confirm-alert/src/react-confirm-alert.css';
import './app.css';
import MaintenancePage from './views/maintenance/MaintenancePage';
import { FeatureFlagsProvider } from './contexts/FeatureFlagsContext';

// -----------------------|| APP ||-----------------------//

const App = () => {
  const customization = useSelector(state => state.customization);

  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

  useEffect(() => {
    let script;
    if (['prod', 'staging'].includes(process.env.REACT_APP_TARGET_ENV)) {
      script = document.createElement('script');
      script.src = process.env.REACT_APP_GA_URL;
      script.async = true;
      document.head.appendChild(script);
    }
    return () => {
      if (['prod', 'staging'].includes(process.env.REACT_APP_TARGET_ENV)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    let script;
    if (['prod', 'staging'].includes(process.env.REACT_APP_TARGET_ENV)) {
      script = document.createElement('script');
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-MR5339M');
      `;
      document.head.insertBefore(script, document.head.firstChild);
    }
    return () => {
      if (['prod', 'staging'].includes(process.env.REACT_APP_TARGET_ENV)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  if (isMaintenanceMode) {
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme(customization)}>
          <CssBaseline />
          <MaintenancePage />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme(customization)}>
        <CssBaseline />
        <Locales>
          <NavigationScroll>
            <ApolloProvider client={client}>
              <FirebaseProvider>
                <DataProvider>
                  <UserProvider>
                    <GrowthbookAppProvider>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <FeatureFlagsProvider>
                          <Routes />
                          <Snackbar />
                        </FeatureFlagsProvider>
                      </LocalizationProvider>
                    </GrowthbookAppProvider>
                  </UserProvider>
                </DataProvider>
              </FirebaseProvider>
            </ApolloProvider>
          </NavigationScroll>
        </Locales>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
